const styles = theme => ({
    content: {
        minHeight: "1000px",
        margin: "auto",
        marginTop: "0",
    },
    appBarSpacer: theme.mixins.toolbar,
    container: {
        paddingTop: 0,
        paddingBottom: theme.spacing(4),
        paddingLeft: 0,
        paddingRight: 0,
    }
});

export default styles;
